import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map, sortBy, filter } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardBar from "../DashboardBar";
import HspTopSymptomsDialog from "./HspTopSymptomsDialog";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const HspTopSymptoms = (props) => {
  const { data, language } = props;

  return (
    <DashboardCard
      title={I18n.get("dashboard_riskCategories")}
      size={sizes.small}
      topNode={
        <HspTopSymptomsDialog
          data={get(data, ["topsymptoms"])}
          language={language}
        />
      }
      id="topSymptomsCard"
    >
      <Grid container direction="column" justify="center" wrap="nowrap">
        {map(
          filter(
            sortBy(get(data, ["topsymptoms"]), (s) => -s.total),
            (item, index) => index < 3
          ),
          (s, i) => (
            <Grid item key={i}>
              <DashboardBar
                title={get(s, [`category_${language}`])}
                value={get(s, ["total"])}
                percentage={get(s, ["percentage"])}
                colors={[colors.dashboardDarkBlue, colors.greyDoughnut]}
                style={{ marginTop: i > 0 ? "5px" : 0, marginBottom: "10px" }}
                idToWatch="topSymptomsCard"
              />
            </Grid>
          )
        )}
      </Grid>
    </DashboardCard>
  );
};

export default HspTopSymptoms;
